/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/phone/setup/QaPhonePlanPreviewSheet.tsx
 * FILE_ID: JOBHUB-QA-PHONE-PREVIEW-001
 * PURPOSE: Full-height sheet around the existing plan preview (unresolved-lines ack stays).
 */
import type { ReactNode } from 'react'
import { MobileSheet } from '@quotech/ui'

export function QaPhonePlanPreviewSheet({
  open,
  onClose,
  children,
}: {
  open: boolean
  onClose: () => void
  children: ReactNode
}) {
  return (
    <MobileSheet open={open} onClose={onClose} title="Review QA plan">
      <div className="p-3">{children}</div>
    </MobileSheet>
  )
}
